import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { ImageTextTriplets } from "../../../components/image-text-triplets";
import explainability from "../../../images/explainability.png";
import actionability from "../../../images/actionability.png";
import customization from "../../../images/customization.png";
import { ParagraphTwins } from "../../../components/paragraph-twins";

export interface DesignerProps {
  sectionId: string;
  index: number;
}

export function Designer(props: DesignerProps) {
  const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
  return (
    <Section sectionId={props.sectionId} isLast={false}>
      <SectionHeader title={`${formattedIndex} For Designers`} />

      <ParagraphGroup
        title="ACE Design Principles"
        body={[
          "Through our research, we surfaced three themes that are key to designing for Human-AI collaborative interventions on social platforms and supporting users in evaluation and reflection. We refer to these themes as the acronym ACE, for Actionability, Customization, and Explainability.",
        ]}
      />

      <ImageTextTriplets
        children={[
          {
            imgSrc: actionability,
            title: "Actionability",
            body:
              "Support users in taking action against misinformation",
          },
          {
            imgSrc: customization,
            title: "Customization",
            body:
              "Allow users to personalize interventions to best help them reach their specific goals",
          },
          {
            imgSrc: explainability,
            title: "Explainability",
            body:
              "Help users understand how features work to establish trust and maximize the effectiveness of interventions",
          },
        ]}
      />
      <ParagraphTwins
        p1={{
          body: [
            "Get an in-depth view of the methods used to establish these principles",
          ],
        }}
        link1={{
          cta: "Read our Research Report",
          url:
            "https://drive.google.com/file/d/1UWOu1O9BXVJDXtvGD-qS-UPO1BRV-maC/view?usp=sharing",
        }}
        p2={{
          body: [
            "Explore an annotated version of the prototype design with notes on functionality and user interaction needs",
          ],
        }}
        link2={{
          cta: "View Annotated Prototype",
          url:
            "https://www.figma.com/file/Thyvdlyo8lQTDVGwjvg0fE/Prototype-Final?node-id=207%3A2675",
        }}
      />
    </Section>
  );
}
